import { forwardRef } from "react";
import { Drawer as DrawerPrimitive } from "vaul";

import {
  DRAWER_OVERLAY_CLASS,
  type TDrawerOverlayElement,
  type TDrawerOverlayProps,
} from "@/ui/components/overlay/Drawer/Drawer.config";
import { cn } from "@/ui/lib/utils";

export const DrawerOverlay = forwardRef<TDrawerOverlayElement, TDrawerOverlayProps>(
  (
    {
      className,
      ...props
    },
    ref,
  ) => (
    <DrawerPrimitive.Overlay
      data-component="DrawerOverlay"
      ref={ref}
      className={cn(DRAWER_OVERLAY_CLASS, className)}
      {...props}
    />
  ),
);

DrawerOverlay.displayName = "DrawerOverlay";
